module.exports = "<p>\n  common works!\n</p>\n"